"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterLoading = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeFilterDropdownButton_1 = require("./DropdownButton/AttributeFilterDropdownButton");
/**
 * Component that displays a loading indicator.
 *
 * @beta
 */
exports.AttributeFilterLoading = function () { return react_1.default.createElement(AttributeFilterDropdownButton_1.AttributeFilterDropdownButton, { isLoading: true }); };
//# sourceMappingURL=AttributeFilterLoading.js.map